<mat-form-field class="full-width">
  <mat-label>{{
    option.label | translate
  }}</mat-label>
  <span *ngIf="option.type === 'password'">
    <input
      name="{{ option.name }}"
      type="{{ option.type | translate }}"
      matInput
      placeholder="{{
        option.placeholder | translate
      }}"
      [value]="option.value? option.value:''"
      autocomplete="{{ option.autocomplete }}"
      showHidePWD
    />
  </span>
  <input
    *ngIf="option.type !== 'password'"
    matInput
    [name]="option.name"
    [type]="option.type"
    [placeholder]="option.placeholder | translate"
    [value]="option.value? option.value:''"
    [autocomplete]="option.autocomplete"
  />
  <mat-hint *ngIf="option.hint !== ''">{{ option.hint | translate }}</mat-hint>
  <mat-hint *ngIf="option.value === ''" class="mat-error">
    {{ option.error | translate }}</mat-hint
  >
</mat-form-field>
